import React from 'react';
import PropTypes from "prop-types";
import {datesConstants} from "mindsets-js-sdk";
import DistrictDropdownItem from "mindsets-js-sdk/src/react/components/DistrictDropdownItem";

import DeleteButton from "./DeleteButton";
import EditButton from "./EditButton";
import DistrictSubscriptionPeriod from "./DistrictSubscriptionPeriod";
import SchoolsCount from "./SchoolsCount";

function Row({item, row_number}) {
    function renderNCESID() {
        if (item.code) {
            return (
                <div>({item.code})</div>
            );
        }

        return null;
    }

    function renderCreatedBy() {
        if (item.user) {
            return (
                <div>{item.user.fname} {item.user.lname} ({item.user.email})</div>
            );
        }

        return (
            <div>n/a</div>
        );
    }

    return (
        <tr key={item.id}>
            <td>{row_number}</td>
            <td>
                {item.id}
                {renderNCESID()}
            </td>
            <td><DistrictDropdownItem item={item}/></td>
            <td className="text-center"><SchoolsCount district={item}/></td>
            <td className="text-center">{item.teachers_count}</td>
            <td className="text-center">{item.students_count}</td>
            <td><DistrictSubscriptionPeriod district={item}/></td>
            <td>
                {renderCreatedBy()}
                {new Date(item.created_at * 1000).toLocaleDateString('en-US', datesConstants.US_DATE_FORMAT)}
            </td>
            <td>
                <div className='d-flex flex-gap-5'>
                    <EditButton id={item.id}/>
                    <DeleteButton id={item.id}/>
                </div>
            </td>
        </tr>
    );
}

Row.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.number.isRequired,
        code: PropTypes.string,
        schools_count: PropTypes.number.isRequired,
        teachers_count: PropTypes.number.isRequired,
        students_count: PropTypes.number.isRequired,
        created_at: PropTypes.number,
        subscriptions: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number.isRequired,
            starts_at: PropTypes.number.isRequired,
            ends_at: PropTypes.number.isRequired
        })),
        user: PropTypes.shape({
            id: PropTypes.number.isRequired,
            email: PropTypes.string.isRequired,
            fname: PropTypes.string,
            lname: PropTypes.string,
        })
    }).isRequired,
    row_number: PropTypes.number.isRequired
};

export default Row;
